export enum ACTION_COURIER_STATUS {
  Set = 'set/COURIER_STATUS',
  Add = 'add/COURIER_STATUS',
  Update = 'update/COURIER_STATUS',
  UnassignOrder = 'remove/COURIER_ORDER',
}

export enum ACTION_ORDER {
  Set = 'set/ORDERS',
  Add = 'add/ODER',
  Update = 'update/ORDER',
}

export enum ACTION_COURIER {
  Set = 'set/COURIERS',
  Add = 'add/COURIER',
  Update = 'update/COURIER',
}

export enum ACTION_ROUTE {
  Set = 'set/ROUTES',
  Add = 'add/ROUTE',
  Update = 'update/ROUTE',
}

export enum ACTION_NAVIGATION {
  SET_ORDER_HASH = 'set/ACTIVE_ORDER_HASH',
  SET_ACTIVE_COURIER = 'set/ACTIVE_COURIER_ID',
  SET_ACTIVE_SCREEN = 'set/ACTIVE_SCREEN',
  SET_ACTIVE_MANAGE_DELIVERY_TAB = 'set/MANAGE_DELIVERY_TAB',
  SET_ACTIVE_ORDER_LIST_FILTER = 'set/ACTIV_ORDER_LIST_FILTER',
  SET_NEW_RECEIVED_ORDER = 'set/NEW_ORDER',
  CLEAR_ACTIVE_COURIER = 'clear/ACTIVE_COURIER',
  CLEAR_ACTIVE_ORDER = 'clear/ACTIVE_ORDER',
  CLEAR_NEW_ORDER = 'clear/NEW_ORDER',
  SET_IS_DATA_LOADED = 'set/DATA_LOADED',
  SET_FORCED_BOTTOMSHEET_SNAP_HEIGHT = 'set/FORCED_BOTTOM_SHEET_SNAP_HEIGHT',
  SET_ACTIVE_POST_CODE_FILTER_VALUES = 'set/ACTIVE_POST_CODE_FILTER_VALUES',
}

export enum ACTION_MAP {
  SET_CENTER = 'set/MAP_CENTER',
  SET_RESTAURANT_COORDINATES = 'set/RESTAURANT_COORDINATES',
  SET_MAP_REFOCUS_TO_CENTER = 'set/MAP_REFOCUS_TO_CENTER',
  SET_ZOOM_LEVEL = 'set/MAP_ZOOM_LEVEL',
  SET_PAN_OFFSET = 'set/MAP_PAN_OFFSET',
  RESET_ZOOM_LEVEL = 'set/RESET_ZOOM_LEVEL',
}

export enum ACTION_LOCATION {
  Update = 'update/COURIER_LOCATION',
}
